import { cn } from "@/lib/utils"

export function LabeledInput({ label, helper, required, prefix, error, touched, ref, ...inputProps }) {
  const invalid = Boolean(touched && error)
  return (
    <div className="space-y-2">
      <label className="text-sm font-semibold text-foreground" htmlFor={inputProps.id ?? inputProps.name}>
        {label} {required ? <span className="text-destructive">*</span> : null}
      </label>
      <div className="relative">
        {prefix ? (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 font-medium text-muted-foreground">
            {prefix}
          </span>
        ) : null}
        <input
          ref={ref}
          id={inputProps.id ?? inputProps.name}
          aria-invalid={invalid || undefined}
          autoComplete="off"
          {...inputProps}
          className={cn(
            "w-full rounded-lg border bg-background py-3 pr-4 text-sm transition-all focus:outline-none focus:ring-2",
            prefix ? "pl-8" : "pl-4",
            invalid
              ? "border-destructive/50 focus:border-destructive focus:ring-destructive/20"
              : "border-border focus:border-primary focus:ring-primary/20",
          )}
        />
      </div>
      {invalid && error?.message ? (
        <p className="text-xs text-destructive">{error.message}</p>
      ) : helper ? (
        <p className="text-xs text-muted-foreground">{helper}</p>
      ) : null}
    </div>
  )
}
